import React, { useState, useEffect } from "react";
import axios from "axios";
import { faHome, faQuran, faTrash, faAngleLeft, faAngleRight, faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Breadcrumb, Col, Row, Form, Card, Button, Table, Container, InputGroup, Modal, Tab, Nav, Tabs } from '@themesberg/react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { baseurl, ProjectStatus, companies, Type, Acknowledgement, Forward,bucketName } from "../../api";
import { triggerFunction, getPredefinedUrl } from '../../components/SignedUrl';
import { useHistory, useParams } from 'react-router-dom';
import { check } from '../../checkloggedin';
import Multiselect from "../../components/Multiselect";
import { useSelector, useDispatch } from 'react-redux';
import { fetchAsyncData } from '../../features/userslice'
import { deletetasks } from "../../features/taskslice";
import { addtaskhistory } from "../../features/taskhistoryslice";
import AddCorrHistory from "../components/AddCorrHistory";
import ViewCorrHistory from "../components/viewCorrHistory.js";
// import ViewTaskHistory from "../components/ViewTaskHistory";
import { fetchProjects } from "../../features/projectslice";
import { addcorrespondence, getcorrespondence, deletecorrespondence } from "../../features/correspondenceSlice";
import AddRefEncl from "./AddRefEncl.js";
import Swal from 'sweetalert2';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import mammoth from "mammoth";
import { render } from "@testing-library/react";
import { timeinIndia } from "../../checkloggedin.js"
export default ({ initialRow = [] }) => {
  const param = useParams();
  const [pname, setPname] = useState('');
  const [people, setPeople] = useState('');
  const [pnamearr, setPnamearr] = useState([]);
  const [taskstatus, setTaskStatus] = useState('');
  const [data, setData] = useState([]);
  const [users, setUsers] = useState([]);
  const [corr, setCorr] = useState([])
  const [date, setDate] = useState('')
  const [typeod, settypeod] = useState("")
  // for edit
  const [taskid, seteditTaskid] = useState("")
  const [editassignTaskTo, setEditassignTaskTo] = useState([])

  const [editCorrid, setEditCorrid] = useState("")
  const [editprojectname, setEditprojectname] = useState("")
  const [edittaskDescription, setEdittaskDescription] = useState("")
  const [edittaskSubject, setEdittaskSubject] = useState("")
  const [editFrom, setEditFrom] = useState("")
  const [editTo, setEditTo] = useState("")
  const [editdate, seteditdate] = useState(null)
  const [editType, setEditType] = useState("");
  const [editAcknowledgement, setEditAcknowledgement] = useState();
  const [editForwarded, setEditForwarded] = useState();
  const [editletterno, seteditletterno] = useState([])
  const [editMode, setEditMode] = useState(false);
  const [editFiles, setEditFiles] = useState([]);
  const [editFiles1, setEditFiles1] = useState([]);
  const [editstatus, setEditStatus] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [showDynamicModal, setShowDynamicModal] = useState(false);
  const [currentRow, setCurrentRow] = useState(initialRow);
  const [editCompany, setEditCompany] = useState('');
  const [showModal3, setShowModal3] = useState(false);
  let [selectedFile, setSelectedFile] = useState(null);
  let [selectedFile1, setSelectedFile1] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredData, setFiltereData] = useState([]);
  const [showAdditionalFiles, setShowAdditionalFiles] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);

  // project filtering
  let [companyname, setCompanyName] = useState('')
  let [isActive, setIsActive] = useState(null)

  // view task History
  const [history, setHistory] = useState([])
  const [taskthis, settaskthis] = useState(false);
  const [showModal1, setShowModal1] = useState(false);

  //view add History
  const [texthistory, setaddtexthistory] = useState("")
  const [showModal2, setShowModal2] = useState(false);
  const [projectname, setprojectname] = useState("")

  //Created Option 
  let [createdoption, setCreatedoption] = useState(0)


  // Created Correspondence
  let [corrdetails, setcorrdetails] = useState({})
  let [files, setfiles] = useState([])
  let [id, setid] = useState("")
  const [fileExtension, setFileExtension] = useState('')
  const [stop, setStop] = useState(true)
  const [editselectedusers, setEditSelectedusers] = useState([])
  const [isFileSelected, setIsFileSelected] = useState(false);
  const [folderName, setFolderName] = useState('');
  const [rows, setRows] = useState(initialRow);
  let [url1, setUrl1] = useState('');
  let [key1, setKey1] = useState('');
  let [url2, setUrl2] = useState('');
  let [key2, setKey2] = useState('');
  const [filterFrom, setFilterFrom] = useState("");
  const [filterTo, setFilterTo] = useState("");
  const [filterForwarded, setFilterForwarded] = useState("");
  const [filterAcknowledgement, setFilterAcknowledgement] = useState("");
  const [isDisabled, setisDisabled] = useState(false)
  const [year, setyear] = useState("")
  let [usedcorr, setusedcorr] = useState([])

  // let [current,setCurrent] = useState('')

  // common for all
  const dispatch = useDispatch();

  // for users
  const { user1, loading, error } = useSelector((state) => state.users);
  const { correspondence } = useSelector((state) => state.correspondence);

  const regex = new RegExp(searchTerm, 'i');

  const token = localStorage.getItem('token');

  const [contacts, setContacts] = useState([]); // State to hold contact data

  const [docxContent, setDocxContent] = useState("");
  let [docx, setDocx] = useState({});
  let [stack, setStack] = useState([])

  // Pagination
  const [correspondences, setCorrespondences] = useState([]);
  const [triggerSubmit, settriggerSubmit] = useState(false)
  const [page, setPage] = useState(1);
  const [limit] = useState(10); // or make this a dropdown option
  const [totalPages, setTotalPages] = useState(1);
  const [search, setSearch] = useState("");
  const [editcstatus, setEditcstatus] = useState("")
  const fetchCorrespondences = async ({
    page = 1,
    limit = 10,
    searchTerm = "",
    cstatus = "",
    forwarded = "",
    from = "",
    to = "",
    projectId = ""
  }) => {
    try {
      const response = await axios.get(`${baseurl}/correspondence/get`, {
        params: {
          page,
          limit,
          date: year,
          search: searchTerm,
          type: typeod,
          cstatus: "",
          acknowledgement: filterAcknowledgement,
          from: filterFrom,
          to: filterTo,
          forwarded: filterForwarded,
          projectId,
          isDisabled
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching correspondences:", error);
      return { data: [], totalItems: 0 };
    }
  };
  useEffect(() => {
    const loadData = async () => {
      const res = await fetchCorrespondences({
        page,
        limit,
        searchTerm
      });
      console.log(res.data)
      setCorr(res.data);
      setTotalPages(res.totalPages);
    };
    loadData();
  }, [triggerSubmit, page]);



  useEffect(() => {
    const fetchContacts = async () => {
      try {
        const response = await axios.put(`${baseurl}/contact/all`); // Adjust API endpoint if necessary
        // console.log(response.data)
        setContacts(response.data); // Set the fetched contact data in the state
      } catch (error) {
        console.error('Error fetching contact:', error);
      }
    };

    fetchContacts();
  }, []);




  useEffect(() => {
    (async () => {
      try {
        const response = await axios.put(`${baseurl}/task/filter`, {
          projectid: pname || undefined,
          assignTaskTo: people ? [people] : undefined,
          taskCompleted: taskstatus || undefined
        });

        // Check if the response status is 200
        setData(response.data);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    })();

    dispatch(fetchAsyncData());

    if (user1.length !== 0) {
      setUsers(user1);
    }

    handleprojectFetch();
  }, [user1.length]);





  const getLetterNoById = (id) => {
    // Find correspondence item by ID and return the letterNo
    const correspondence = usedcorr.find((item) => item._id === id);
    // console.log(corr)

    if (correspondence) {
      return correspondence.letterno.toString()
    }

  };

  const getallcorrespondence = (corrid, from) => {

    dispatch(getcorrespondence()).then((resp) => {
      setCorr(resp)
      handleCorrhistory({ _id: corrid }, from)
      // //////console.log(resp)
    }).catch(error => {
      console.log(error)
    })
  }

  const handleCorrhistory = async (row, from) => {
    ////////////////console.log("hi")

    // console.log(row._id)
    let singlecorr = corr.find((value) => value._id == row._id)
    // console.log(singlecorr)
    files = singlecorr.files
    if (from == false) {
      setfiles(singlecorr.files)
    }
    setid(row._id)
    setShowModal1(true)
    settaskthis(true)
  }


  const handleprojectFetch = async () => {
    ////////////////console.log(companyname)
    dispatch(fetchProjects({
      company: companyname ? companyname : null,
      status: isActive ? isActive : null
    })).then((resp) => {
      setPnamearr(resp)
      //////console.log(resp)
    }).catch(error => {

    })
  }
  const handleFetch = async (e) => {
    e.preventDefault()

    try {
      const response = await axios.put(`${baseurl}/task/filter`, {
        projectid: pname || undefined,
        assignTaskTo: people ? [people] : undefined,
        taskCompleted: taskstatus || undefined
      });
      setData(response.data);
      //////console.log(response.data)

    } catch (error) {
      //console.error(error);
    }
  };


  const handleComplete = (id) => {
    // Find the task with the given id and toggle its completion status locally
    const updatedData = data.map(item => {
      if (item._id === id) {
        return { ...item, taskCompleted: !item.taskCompleted };
      }
      return item;
    });

    // Update the state with the modified data
    setData(updatedData);

    // Make the PUT request to update the task completion status on the server
    axios.put(`${baseurl}/task/complete/${id}`)
      .then(response => {
        // Handle success response if needed
      })
      .catch(error => {
        // If the request fails, revert the local state change
        //console.error(error);
        setData(data); // Revert back to the original data
      });
  };
  const handleEditModal = (item) => {
    // let temp = []
    // let tempuser = item.assignTaskTo
    // for (let j = 0; j < users.length; j++) {
    //   if ((tempuser).includes(users[j]._id)) {
    //     temp.push({
    //       id: users[j]._id,
    //       name: users[j].username,
    //     })
    //   }
    // }
    ////////////////console.log(temp,"hi")
    // seteditTaskid(item._id)
    // setEditassignTaskTo(temp)
    setEditCorrid(item._id)
    setEditprojectname(item.project)
    setEdittaskDescription(item.description)
    setEdittaskSubject(item.subject)
    setEditFrom(item.from)
    setEditTo(item.to)
    seteditletterno(item.letterno)
    seteditdate(item.date)
    setEditType(item.type)
    setEditAcknowledgement(item.acknowledgement)
    setEditForwarded(item.forwarded)
    setEditFiles(item.files)
    setEditFiles1(item.files1)
    setEditStatus(item.cstatus)
    setShowModal3(true);
    setEditMode(true); // Set editMode to true when opening the edit modal
  }


  const timeinIndia = (date) => {
    const utcTime = new Date(date);
    // console.log(utcTime)
    const istTime = utcTime.toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' });
    return (istTime);
  }
  const sortbycreatedby = () => {
    // Increment the createdoption to toggle through sorting states
    let temp = createdoption + 1;
    if (temp > 2) {
      temp = 1; // Reset to 1 if it exceeds the number of sorting options
    }
    setCreatedoption(temp);

    // Make a copy of the data array to avoid mutating the state directly
    let sortedData = [...corr]; // Ensure corr is the state being rendered

    // Sort the data based on created date
    if (temp === 1) {
      // Ascending order: Oldest first
      sortedData.sort((a, b) => new Date(a.date) - new Date(b.date));
    } else if (temp === 2) {
      // Descending order: Newest first
      sortedData.sort((a, b) => new Date(b.date) - new Date(a.date));
    }

    setCorr(sortedData); // Update the state with the sorted data
  };

  const handleaddhistory = async (row, projectname) => {
    // console.log(row)
    // row.projectname = projectname
    try {
      await axios.get(`${baseurl}/correspondence/linked/${row._id}`).then((res) => {
        console.log("Linked:", res.data);
        // usedcorr=res.data
        // console.log(usedcorr)
        setusedcorr(res.data)
        setcorrdetails(row)
      })
      setTimeout(() => {
        setShowModal2(true)
      }, 500);

    } catch (err) {
      console.error("Linked fetch error:", err);
    }

    // seteditTaskid(row._id)
    // dispatch(addtaskhistory("hi"))

  }

  const handleRefClick = async (row) => {
    // console.log(row)
    try {
      await axios.get(`${baseurl}/correspondence/linked/${row._id}`).then((res) => {
        console.log("Linked:", res.data);
        setusedcorr(res.data)
      })
      setTimeout(() => {
        setSelectedRow(row);
        setShowModal(true);
      }, 10);

    } catch (err) {
      console.error("Linked fetch error:", err);
    }

  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedRow(null);
  };

  const handleDocumentClick = async (document) => {
    // console.log(selectedRow._id)
    stack.push(selectedRow._id)
    // current=document
    // setStack((prev) => [...prev, document]);
    // console.log(stack)
    const newcorr = usedcorr.find((val) => val._id == document)
    //   const newRow = findprojectname(document); // Mock function to get the new row details based on the document ID or reference.
    // //   if (newRow) {
    // //     setShowDynamicModal((prevModals) => [...prevModals, document]);
    // //   }
    // //   cons
    try {
      await axios.get(`${baseurl}/correspondence/linked/${document}`).then((res) => {
        console.log("Linked:", res.data);
        setusedcorr(prev => [...prev, ...res.data])
      })
      setTimeout(() => {
        setSelectedRow(newcorr); // Set the new row to be displayed in the modal
        setShowDynamicModal(true); // Re-open the modal with new details
      }, 10);

    } catch (err) {
      console.error("Linked fetch error:", err);
    }


  };

  const handleCloseDynamicModal = () => {
    setShowDynamicModal((prevModals) => prevModals.slice(0, - 1)); // Close the current dynamic modal
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    setStop(false);
    if (file) {
      const fileExtension = file.name;
      setSelectedFile1(file);
      setFileExtension(fileExtension);

      try {
        const [url, key] = await triggerFunction(fileExtension, folderName);
        setUrl1(url); // For the first file
        setKey1(key); // For the first file
        setIsFileSelected(true);
      } catch (error) {
        console.error('Error triggering function:', error);
        toast.error('Failed to process the file');
      }
    } else {
      setSelectedFile1(null);
      setFileExtension('');
      setIsFileSelected(false);
    }
    setStop(true)
  };

  const handleFileChange1 = async (event) => {
    const file = event.target.files[0];
    setStop(false);
    if (file) {
      const fileExtension = file.name;
      setSelectedFile(file);
      setFileExtension(fileExtension);

      try {
        const [url, key] = await triggerFunction(fileExtension, folderName);
        url2 = url
        setUrl2(url); // For the second file
        // key2 = key
        setKey2(key); // For the second file
        // console.log(url2)
        setIsFileSelected(true);
      } catch (error) {
        console.error('Error triggering function:', error);
        toast.error('Failed to process the file');
      }
    } else {
      setSelectedFile(null);
      setFileExtension('');
      setIsFileSelected(false);
    }
    setStop(true)
  };




  const handleEditSubmit = async (e) => {
    e.preventDefault();

    let file1UploadSuccess = true; // Assume success by default
    let file2UploadSuccess = true; // Assume success by default

    const fileUploadHandler = async (file, uploadUrl) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = async (event) => {
          const fileContent = event.target.result;

          try {
            const responseFile = await fetch(uploadUrl, {
              method: 'PUT',
              body: fileContent,
              headers: {
                'Content-Type': 'application/octet-stream',
              },
              mode: 'cors',
            });

            if (!responseFile.ok) {
              throw new Error('Network response was not ok');
            }

            toast.success('File Uploaded Successfully');
            resolve(true); // Indicate success
          } catch (error) {
            console.error('Error uploading file:', error);
            toast.error('Failed to add image');
            resolve(false); // Indicate failure
          }
        };
        reader.readAsArrayBuffer(file);
      });
    };

    // Upload files and track success/failure
    if (selectedFile1) {
      file1UploadSuccess = await fileUploadHandler(selectedFile1, url1);
    }
    if (selectedFile) {
      file2UploadSuccess = await fileUploadHandler(selectedFile, url2);
    }

    // Only proceed if both file uploads succeeded
    if (!file1UploadSuccess || !file2UploadSuccess) {
      toast.error('File upload failed. Data update aborted.');
      return; // Stop further execution if any upload fails
    }

    const token = localStorage.getItem('token');

    // Create the files array by inserting new data if a new file was uploaded
    let files = [...editFiles]; // Copy the existing files

    if (selectedFile1) {
      // Determine the next available index for the new file
      const nextIndex = files.length;

      files.push({
        order: nextIndex,
        description: '',
        date: new Date().toISOString(),
        filename: selectedFile1.name,
        current: getPredefinedUrl(key1),
        prevlinks: files[nextIndex] && files[nextIndex].current ? [files[nextIndex].current] : [], // Only add to prevlinks if there's an existing current file
        isDisabled: false,
      });
    }

    // Same logic for files1 array
    let files1 = [...editFiles1];

    if (selectedFile) {
      const nextIndex1 = files1.length;

      files1.push({
        order: nextIndex1,
        description: '',
        date: new Date().toISOString(),
        filename: selectedFile.name,
        current: getPredefinedUrl(key2),
        prevlinks: files1[nextIndex1] && files1[nextIndex1].current ? [files1[nextIndex1].current] : [], // Only add to prevlinks if there's an existing current file
        isDisabled: false,
      });
    }

    const editData = {
      date: editdate,
      type: editType,
      from: editFrom,
      to: editTo,
      acknowledgement: editAcknowledgement,
      forwarded: editForwarded,
      description: edittaskDescription,
      letterno: editletterno,
      subject: edittaskSubject,
      files: files,
      files1: files1,
      cstatus: editstatus
    };

    try {
      const response = await axios.put(
        `${baseurl}/correspondence/updatecorr/${editCorrid}`,
        editData,
        {
          headers: { Authorization: ` ${token}` },
        }
      );

      if (response.status === 200) {
        toast.success('Data updated successfully');
        // toast.success('Remeber to add References');
        // setShowModal2(true)
        setShowModal(false);
        handleprojectFetch();
        setShowModal3(false);
        // setcorrdetails(e)
        // seteditTaskid(row._id)
        // setShowModal2(true)
        // handleaddhistory(editData, editprojectname); // Ensure you pass correct parameters (row and projectname)
        ///////////////////////

        setSelectedFile(null);
        setFileExtension(null);
        setUrl1(null); // For the first file
        setKey1(null); // For the first file

        setSelectedFile1(null);
        setFileExtension(null);
        setUrl2(null); // For the first file
        setKey2(null); // For the first file


        settriggerSubmit(prev => !prev)




        ////////////////////
        // Fetching correspondence and setting updated data
        // dispatch(getcorrespondence())
        //   .then((resp) => {
        //     setCorr(resp);
        //   })
        //   .catch((error) => {
        //     // console.log(error);
        //   });

        // Call handleaddhistory after successful updat
      }
    } catch (error) {
      console.error('Error updating record:', error);
      toast.error('Failed to update record');
    }
  };



  // Inside your component or wherever you are handling the delete
  const handleDelete = async (id) => {
    try {
      // Make API call to delete the correspondence
      const response = await axios.delete(`${baseurl}/correspondence/correspondences/delete/${id}`, {
        params: {
          deletedate: Date.now(),
        },
        headers: {
          Authorization: `${token}`,
        },
      });
      // Check if the response is successful
      if (response.status === 200) {
        // Optional: Trigger a success toast notification
        toast.success("Correspondence deleted successfully!");
        settriggerSubmit(prev => !prev)
        // Dispatch the getcorrespondence function to refresh correspondence list
        // dispatch(getcorrespondence())
        //   .then((resp) => {
        //     // setCorr(resp); // Update state with new correspondence data
        //     let temp = resp.filter((item) => item.isDisabled == isDisabled)
        //     setCorr(temp)
        //   })
        //   .catch((error) => {
        //     console.log("Error fetching updated correspondence:", error);
        //   });
      } else {
        // Handle failure response if status is not 200
        throw new Error("Failed to delete correspondence");
      }
    } catch (error) {
      console.error("Error deleting correspondence:", error);

      // Optional: Trigger an error toast notification
      toast.error("Failed to delete correspondence. Please try again.");
    }
  };



  const findprojectname = (projectId) => {
    const project = pnamearr.find((option) => option._id === projectId);
    return project ? project.name : null;
  };

  // docx
  const renderDocx = async (fileUrl, id) => {
    try {
      // console.log(id)
      const response = await fetch(fileUrl);
      const arrayBuffer = await response.arrayBuffer();
      await mammoth.convertToHtml({ arrayBuffer }).then(result => {
        // console.log(result.value)
        docx[id] = (result.value).toString()
        setDocx(prevDocs => ({
          ...prevDocs, // Spread the existing state
          [id]: (result.value).toString() // Update the specific key
        }));
        // setDocxContent((result.value).toString())
        return (result.value).toString()
      }
      );


      // setDocxContent(value);
    } catch (error) {
      console.error("Error rendering .docx file:", error);
      setDocxContent("<p>Unable to load the document</p>");
    }
  };
  const handleGoBack = () => {
    // handleDocumentClick()
    // console.log(stack)
    if (stack.length == 0) {
      // console.log("here")
      setShowModal(false)
      return
    }
    let temp = stack.pop()

    const newcorr = corr.find((val) => val._id == temp)
    setSelectedRow(newcorr); // Set the new row to be displayed in the modal
    setShowDynamicModal(true); // Re-open the modal with new details
  };
  const downloadFile = async (fileUrl) => {
    try {
      // Fetch the file
      const urlParts = fileUrl.split('/');
      // Replace the domain part (e.g., ${bucketName})
      urlParts[2] = urlParts[2].replace(/^[^\.]+/, bucketName);
      fileUrl = urlParts.join('/');
      console.log(fileUrl)
      const response = await fetch(fileUrl);
      if (!response.ok) {
        throw new Error("Failed to fetch file");
      }
      const blob = await response.blob();

      // Extract the filename from the URL
      const fileName = urlParts[urlParts.length - 1];

      // Create a link element and download the file with the extracted name
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName; // Use the extracted file name
      document.body.appendChild(a);
      a.click();

      // Cleanup
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading the file:", error);
    }
  }
  return (
    <>
      <ToastContainer />
      <form onSubmit={handleFetch}>
        <Row>
          <Col xs={12} md={4}>
            <Form.Group id="search" className="mb-4">
              <Form.Label>Search</Form.Label>
              <InputGroup>
                <InputGroup.Text></InputGroup.Text>
                <Form.Control
                  type="text"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  placeholder="Search..."
                />
              </InputGroup>
            </Form.Group>
          </Col>
          <Col xs={12} md={4}>
            <Form.Group id="search" className="mb-4">
              <Form.Label>yyyy-mm-dd Search</Form.Label>
              <InputGroup>
                <InputGroup.Text></InputGroup.Text>
                <Form.Control
                  type="text"
                  value={year}
                  onChange={e => {
                    setyear(e.target.value)
                    // handleSearchDate(e);
                  }}
                  placeholder="Search..."
                />
              </InputGroup>
            </Form.Group>
          </Col>
          <Col xs={12} md={4}>
            <Form.Label>From</Form.Label>
            <Form.Select
              value={filterFrom}
              onChange={(e) => setFilterFrom(e.target.value)} // Update editFrom when dropdown changes
            >
              <option value="">Select Option</option>
              {contacts
                .sort((a, b) => a.name.localeCompare(b.name))
                .map((contact, index) => (
                  <option key={index} value={contact.name}>
                    {contact.name}
                  </option>
                ))}
            </Form.Select>
          </Col>
          <Col xs={12} md={4}>
            <Form.Label>To</Form.Label>
            <Form.Select
              value={filterTo}
              onChange={(e) => setFilterTo(e.target.value)} // Update editTo when dropdown changes
            >
              <option value="">Select Option</option>
              {contacts
                .sort((a, b) => a.name.localeCompare(b.name))
                .map((contact, index) => (
                  <option key={index} value={contact.name}>
                    {contact.name}
                  </option>
                ))}
            </Form.Select>
          </Col>

          <Col xs={12} md={4}>
            <Form.Label>Forwarded</Form.Label>
            <Form.Select
              value={filterForwarded}
              onChange={(e) => setFilterForwarded(e.target.value)} // Update filterForwarded when dropdown changes
            >
              <option value="">Select Option</option>
              {Forward.map((option, index) => (
                <option key={index} value={option}>
                  {option}
                </option>
              ))}
            </Form.Select>
          </Col>
          <Col xs={12} md={4}>
            <Form.Label>Acknowledgement</Form.Label>
            <Form.Select
              value={filterAcknowledgement}
              onChange={(e) => setFilterAcknowledgement(e.target.value)} // Update filterForwarded when dropdown changes
            >
              <option value="">Select Option</option>
              {Acknowledgement.map((option, index) => (
                <option key={index} value={option}>
                  {option == "Uploaded" ? "Received" : option}
                </option>
              ))}
            </Form.Select>
          </Col>
          <Col xs={12} md={4}>
            <Form.Label>isDisabled</Form.Label>
            <Form.Select
              value={isDisabled}
              onChange={(e) => {
                // isDisabled=
                setisDisabled(!isDisabled)
              }} // Update filterForwarded when dropdown changes
            >
              <option value={false}>False</option>
              <option value={true}>True</option>
            </Form.Select>
          </Col>
          <Col xs={12} md={4}>
            <Form.Label>Type</Form.Label>
            <Form.Select
              value={typeod}
              onChange={(e) => settypeod(e.target.value)} // Update filterForwarded when dropdown changes
            >
              <option value="">Select Option</option>
              <option value="Letter">Letter</option>
              <option value="Circular">Circular</option>

            </Form.Select>
          </Col>
          <Button onClick={() => settriggerSubmit(prev => !prev)} style={{ width: "30%", marginTop: "2%" }} type="submit">Submit</Button>
        </Row>
      </form>
      <section>
        <Container>
          <Row>
            <Col className="mx-auto">
              <Card style={{ width: "200%", marginLeft: "-10%", paddingLeft: "5%" }} border="light" className="shadow-sm">
                <Card.Header>
                  <Row className="align-items-center">
                    <Col>
                      <h5>Service List</h5>
                    </Col>
                  </Row>
                </Card.Header>
                <Table responsive className="align-items-center table-flush">
                  <thead className="thead-light">
                    <tr>
                      <th scope="col" className="unselectable" style={{ cursor: "pointer" }} onClick={sortbycreatedby}>
                        Created At
                      </th>
                      <th scope="col" className="unselectable" style={{ cursor: "pointer" }} onClick={sortbycreatedby}>
                        {isDisabled ? "Deleted Date" : "Recovered Date"}
                      </th>
                      <th scope="col">Project Name</th>
                      <th scope="col">Letter No</th>
                      {/* <th scope="col">Description</th> */}
                      <th scope="col">Subject</th>
                      <th scope="col">Forward Status</th>
                      <th scope="col">Acknowledgement Status</th>
                      {/* <th scope="col">Reference to</th>
                      <th scope="col">Reference from</th>
                      <th scope="col">Enclosed to</th>
                      <th scope="col">Enclosed from</th> */}
                      <th scope="col">File Current</th>
                      <th scope="col">File1 Current</th>
                      <th scope="col">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {corr.length === 0 ? (
                      <tr>
                        <td colSpan="8" className="text-center">Loading...</td>
                      </tr>
                    ) : (
                      corr.map((row, index) => {
                        const projectName = findprojectname(row.project);
                        return projectName ? (
                          <tr key={index}>
                            <td style={{ whiteSpace: "pre-wrap" }}>{row.date}</td>
                            <td style={{ whiteSpace: "pre-wrap" }}>{row.recoveredDate ? timeinIndia(row.recoveredDate) : ""}</td>

                            <td style={{ whiteSpace: "pre-wrap", textDecoration: "underline", color: "blue", cursor: "pointer" }} onClick={() => {
                              handleRefClick(row)
                              renderDocx(row.files.slice(-1)[0].current.replace(
                                /^(https?:\/\/)([^\/]+)/,
                                (_, protocol, domain) => `${protocol}${bucketName}.${domain.split('.').slice(1).join('.')}`
                              ), row._id)
                              // current=row._id
                            }}>
                              {projectName}
                            </td>
                            <td style={{ whiteSpace: "pre-wrap" }}>{row.letterno}</td>
                            {/* <td ><pre style={{ width: "20%", whiteSpace: "pre-wrap" }}>{row.description}</pre></td> */}
                            <td><pre style={{ whiteSpace: "pre-wrap" }}>{row.subject}</pre></td>
                            <td style={{ whiteSpace: "pre-wrap" }}>{row.forwarded}</td>
                            <td style={{ whiteSpace: "pre-wrap" }}>{row.acknowledgement == "Uploaded" ? "Recieved" : row.acknowledgement}</td>
                            {/* Reference To */}
                            {/* <td style={{ whiteSpace: "pre-wrap" }}>
                              <ul style={{ listStyleType: 'none' }}>
                                {row.refto && row.refto.map((document, index) => (
                                  <li key={index} style={{ marginBottom: '5px', paddingLeft: '20px', textIndent: '-15px' }}>
                                    • <a style={{ textDecoration: "underline", cursor: "pointer" }} >
                                      {document}
                                    </a>
                                  </li>
                                ))}
                              </ul>
                            </td> */}
                            {/* Reference From */}
                            {/* <td style={{ whiteSpace: "pre-wrap" }}>
                              <ul style={{ listStyleType: 'none' }}>
                                {row.reffrom && row.reffrom.map((document, index) => (
                                  <li key={index} style={{ marginBottom: '5px', paddingLeft: '20px', textIndent: '-15px' }}>
                                    • <a style={{ textDecoration: "underline", cursor: "pointer" }} onClick={() => handleRefClick(row)}>
                                      {document}
                                    </a>
                                  </li>
                                ))}
                              </ul>
                            </td> */}
                            {/* Enclosed To */}
                            {/* <td style={{ whiteSpace: "pre-wrap" }}>
                              <ul style={{ listStyleType: 'none' }}>
                                {row.refto && row.refto.map((document, index) => (
                                  <li key={index} style={{ marginBottom: '5px', paddingLeft: '20px', textIndent: '-15px' }}>
                                    • <a style={{ textDecoration: "underline", cursor: "pointer" }} onClick={() => handleRefClick(row)}>
                                      {document}
                                    </a>
                                  </li>
                                ))}
                              </ul>
                            </td> */}
                            {/* Enclosed From */}
                            {/* <td style={{ whiteSpace: "pre-wrap" }}>
                              <ul style={{ listStyleType: 'none' }}>
                                {row.reffrom && row.reffrom.map((document, index) => (
                                  <li key={index} style={{ marginBottom: '5px', paddingLeft: '20px', textIndent: '-15px' }}>
                                    • <a style={{ textDecoration: "underline", cursor: "pointer" }} onClick={() => handleRefClick(row)}>
                                      {document}
                                    </a>
                                  </li>
                                ))}
                              </ul>
                            </td> */}
                            {/* File Current */}
                            <td colSpan="1">
                              {row.files && row.files.length > 0 ? (
                                <pre style={{ whiteSpace: "pre-wrap" }}>
                                  {row.files.slice(-1).map((file, index) => (
                                    <a
                                      key={index}
                                      onClick={() => { downloadFile(file.current) }}
                                      style={{ textDecoration: "underline", color: "blue" }}
                                    >
                                      Link
                                    </a>
                                  ))}
                                </pre>
                              ) : (
                                <span>No appointment letters available</span>
                              )}
                            </td>
                            {/* File1 Current */}
                            <td colSpan="1">
                              {row.files1 && row.files1.length > 0 ? (
                                <pre style={{ whiteSpace: "pre-wrap" }}>
                                  {row.files1.slice(-1).map((file, index) => (
                                    <a
                                      key={index}
                                      onClick={() => { downloadFile(file.current) }}

                                      style={{ textDecoration: "underline", color: "blue" }}
                                    >
                                      Acknowledgement Letter
                                    </a>
                                  ))}
                                </pre>
                              ) : (
                                <span>No acknowledgement letters available</span>
                              )}
                            </td>
                            <td>
                              <Button style={{ backgroundColor: "aqua", color: "black" }} variant="info" size="sm" onClick={() => handleEditModal(row)}>
                                <FontAwesomeIcon icon={faEdit} />
                              </Button>
                              <Button style={{ borderColor: "black", backgroundColor: "aqua", color: "black", marginLeft: "2%" }} onClick={() => handleDelete(row._id)} variant="danger" size="sm">
                                <FontAwesomeIcon icon={faTrash} />
                              </Button>
                              <Button style={{ backgroundColor: "aqua", color: "black", marginLeft: "2%" }} onClick={() => handleaddhistory(row, projectName)}>Add</Button>
                              {/* <Button
                                style={{ backgroundColor: "aqua", color: "black", marginLeft: "2%" }}
                                onClick={() => handleComplete(row._id)}
                              >
                                {row.taskCompleted ? "Mark incomplete" : "Mark complete"}
                              </Button> */}
                            </td>
                          </tr>
                        ) : null;
                      })
                    )}
                  </tbody>
                </Table>
              </Card>
            </Col>
          </Row>

          {/* Dynamic Modal */}
          <Modal
            style={{ overflowX: 'auto' }}
            className="xxl-down"
            show={showModal} onHide={handleCloseModal} >
            <div style={{ width: "1200px", backgroundColor: "white", overflowX: 'auto', overflowY: 'auto', border: "3px solid red", borderRadius: "10px" }}>
              <Button onClick={() => handleGoBack()}>Go Back</Button>
              <div style={{
                width: "100%", display: 'flex', justifyContent: 'space-between', gap: '20px',
                overflowX: 'auto', overflowY: 'auto'
              }}>
                <div
                  style={{
                    // flex: '3', // Increased from '1' to '3' for more space
                    width: "20%",
                    border: '1px solid grey',
                    padding: '0px',
                    textAlign: 'center',
                    // height: '1000px', // Optional: Increase the height as needed
                    // overflowY: 'auto', // Optional: Allows scrolling if content exceeds height
                    // overflowX: 'auto',
                  }}
                >
                  <h1>Replies</h1>
                  {selectedRow && (
                    <ul style={{ listStyleType: 'none' }}>
                      {selectedRow.replyto && selectedRow.replyto.map((id, index) => {
                        let temp = usedcorr?.find((item) => item._id === id);
                        renderDocx(temp?.files?.slice(-1)[0].current, id)

                        // console.log(temp)
                        return (
                          <div style={{
                            height: "900px",
                            overflowY: 'auto', // Optional: Allows scrolling if content exceeds height
                            border: "1px solid grey",
                            borderRadius: "20px" // Optional: Allows scrolling if content exceeds height

                          }}>
                            <pre
                              onClick={() => handleDocumentClick(id)}
                              style={{ cursor: "pointer", padding: "10px", whiteSpace: "pre-wrap", textDecoration: 'underline' }}>-{getLetterNoById(id)} </pre>
                            <p>{temp.description}</p>
                            <li
                              key={index}
                              // onClick={() => handleDocumentClick(id)}
                              style={{ cursor: 'pointer', textDecoration: 'underline' }}
                            >
                              {/* Display Letter No */}
                              {/* <pre style={{ whiteSpace: "pre-wrap" }}>-{getLetterNoById(id)} </pre> */}
                              {temp && temp.files && temp.files.length > 0 ? (

                                temp.files.slice(-1)[0].current.replace(
                                  /^(https?:\/\/)([^\/]+)/,
                                  (_, protocol, domain) => `${protocol}${bucketName}.${domain.split('.').slice(1).join('.')}`
                                ).endsWith(".pdf") ? (
                                  <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js`}>
                                    <Viewer fileUrl={temp.files.slice(-1)[0].current.replace(
                                      /^(https?:\/\/)([^\/]+)/,
                                      (_, protocol, domain) => `${protocol}${bucketName}.${domain.split('.').slice(1).join('.')}`
                                    )} />
                                  </Worker>
                                ) : temp.files.slice(-1)[0].current.replace(
                                  /^(https?:\/\/)([^\/]+)/,
                                  (_, protocol, domain) => `${protocol}${bucketName}.${domain.split('.').slice(1).join('.')}`
                                ).endsWith(".docx") ? (
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: docx[id]                                      // __html: docxContent

                                      // "<p>Unable to load the document</p>"
                                    }}
                                    style={{ padding: "15px", border: "1px solid #ddd" }}
                                  />
                                ) : (
                                  <p>Unsupported file format</p>
                                )
                              ) : (
                                <p>No files available</p>
                              )}
                            </li>
                          </div>
                        )
                      })}
                    </ul>
                  )}
                </div>
                <div
                  style={{
                    // flex: '3', // Increased from '1' to '3' for more space
                    width: "20%",
                    border: '1px solid grey',
                    padding: '0px',
                    textAlign: 'center',
                    // height: '1000px', // Optional: Increase the height as needed
                    // overflowY: 'auto', // Optional: Allows scrolling if content exceeds height
                  }}
                >
                  <h1>Reply of</h1>
                  {selectedRow && (
                    <ul style={{ listStyleType: 'none' }}>
                      {selectedRow.replyfrom && selectedRow.replyfrom.map((id, index) => {
                        let temp = usedcorr?.find((item) => item._id === id);
                        renderDocx(temp?.files?.slice(-1)[0].current, id)

                        // console.log(temp)
                        return (
                          <div style={{
                            height: "900px",
                            overflowY: 'auto', // Optional: Allows scrolling if content exceeds height
                            border: "1px solid grey",
                            borderRadius: "20px" // Optional: Allows scrolling if content exceeds height

                          }}>
                            <pre
                              onClick={() => handleDocumentClick(id)}
                              style={{ cursor: "pointer", padding: "10px", whiteSpace: "pre-wrap", textDecoration: 'underline' }}>-{getLetterNoById(id)} </pre>
                            <p>{temp.description}</p>
                            <li
                              key={index}
                              // onClick={() => handleDocumentClick(id)}
                              style={{ cursor: 'pointer', textDecoration: 'underline' }}
                            >
                              {/* Display Letter No */}
                              {/* <pre style={{ whiteSpace: "pre-wrap" }}>-{getLetterNoById(id)} </pre> */}
                              {temp && temp.files && temp.files.length > 0 ? (

                                temp.files.slice(-1)[0].current.replace(
                                  /^(https?:\/\/)([^\/]+)/,
                                  (_, protocol, domain) => `${protocol}${bucketName}.${domain.split('.').slice(1).join('.')}`
                                ).endsWith(".pdf") ? (
                                  <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js`}>
                                    <Viewer fileUrl={temp.files.slice(-1)[0].current.replace(
                                      /^(https?:\/\/)([^\/]+)/,
                                      (_, protocol, domain) => `${protocol}${bucketName}.${domain.split('.').slice(1).join('.')}`
                                    )} />
                                  </Worker>
                                ) : temp.files.slice(-1)[0].current.replace(
                                  /^(https?:\/\/)([^\/]+)/,
                                  (_, protocol, domain) => `${protocol}${bucketName}.${domain.split('.').slice(1).join('.')}`
                                ).endsWith(".docx") ? (
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: docx[id]                                      // __html: docxContent

                                      // "<p>Unable to load the document</p>"
                                    }}
                                    style={{ padding: "15px", border: "1px solid #ddd" }}
                                  />
                                ) : (
                                  <p>Unsupported file format</p>
                                )
                              ) : (
                                <p>No files available</p>
                              )}
                            </li>
                          </div>
                        )
                      })}
                    </ul>
                  )}
                </div>
                <div
                  style={{
                    // flex: '3', // Increased from '1' to '3' for more space
                    width: "35%",
                    border: '1px solid grey',
                    padding: '0px',
                    textAlign: 'center',
                    // height: '1000px', // Optional: Increase the height as needed
                    // overflowY: 'auto', // Optional: Allows scrolling if content exceeds height
                  }}
                >
                  <div>
                    <h1 style={{ textAlign: 'center' }}>Status:{selectedRow && selectedRow.forwarded}</h1>
                    <pre style={{ whiteSpace: "pre-wrap" }}>{selectedRow && selectedRow.cstatus}</pre>
                    <p>Letter No:-{selectedRow && selectedRow.letterno}</p>
                  </div>
                  <Tabs defaultActiveKey="files1" id="file-tabs" className="mb-3">
                    {/* Tab for Files */}

                    <Tab eventKey="files1" title="Files">
                      {selectedRow && selectedRow.files && selectedRow.files.length > 0 ? (

                        selectedRow.files.slice(-1)[0].current.replace(
                          /^(https?:\/\/)([^\/]+)/,
                          (_, protocol, domain) => `${protocol}${bucketName}.${domain.split('.').slice(1).join('.')}`
                        ).endsWith(".pdf") ? (
                          <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js`}>
                            <Viewer fileUrl={selectedRow.files.slice(-1)[0].current.replace(
                              /^(https?:\/\/)([^\/]+)/,
                              (_, protocol, domain) => `${protocol}${bucketName}.${domain.split('.').slice(1).join('.')}`
                            )} />
                          </Worker>
                        ) : selectedRow.files.slice(-1)[0].current.replace(
                          /^(https?:\/\/)([^\/]+)/,
                          (_, protocol, domain) => `${protocol}${bucketName}.${domain.split('.').slice(1).join('.')}`
                        ).endsWith(".docx") ? (
                          <div
                            dangerouslySetInnerHTML={{
                              __html: docx[selectedRow._id]

                              // "<p>Unable to load the document</p>"
                            }}
                            style={{ padding: "15px", border: "1px solid #ddd" }}
                          />
                        ) : (
                          <p>Unsupported file format</p>
                        )
                      ) : (
                        <p>No files available</p>
                      )}
                    </Tab>
                    <Tab eventKey="files2" title="Acknowledgement Letters">
                      {selectedRow && selectedRow.files1 && selectedRow.files1.length > 0 && selectedRow.files1.slice(-1)[0].current.replace(
                        /^(https?:\/\/)([^\/]+)/,
                        (_, protocol, domain) => `${protocol}${bucketName}.${domain.split('.').slice(1).join('.')}`
                      ) ? (
                        <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js`}>
                          <Viewer fileUrl={selectedRow.files1.slice(-1)[0].current.replace(
                            /^(https?:\/\/)([^\/]+)/,
                            (_, protocol, domain) => `${protocol}${bucketName}.${domain.split('.').slice(1).join('.')}`
                          )} />
                        </Worker>
                      ) : (
                        <div style={{ textAlign: 'center', color: 'gray' }}>
                          <p>No acknowledgement letters available</p>
                        </div>
                      )}
                    </Tab>
                    <Tab eventKey="files4" title="Details">
                      {selectedRow ? (
                        <>
                          <table>
                            <tbody>
                              <tr>
                                <td><strong>Created At:</strong></td>
                                <td>{timeinIndia(selectedRow.date)}</td>
                              </tr>
                              <tr>
                                <td><strong>Project Name:</strong></td>
                                <td>{findprojectname(selectedRow.project)}</td>
                              </tr>
                              <tr>
                                <td><strong>Subject:</strong></td>
                                <td><pre style={{ whiteSpace: "pre-wrap" }}>{selectedRow.subject}</pre></td>
                              </tr>
                              <tr>
                                <td><strong>Type:</strong></td>
                                <td>{selectedRow.type}</td>
                              </tr>
                              <tr>
                                <td><strong>From:</strong></td>
                                <td>{selectedRow.from}</td>
                              </tr>
                              <tr>
                                <td><strong>To:</strong></td>
                                <td>{selectedRow.to}</td>
                              </tr>
                              <tr>
                                <td><strong>Letter No:</strong></td>
                                <td>{selectedRow.letterno}</td>
                              </tr>
                              <tr>
                                <td><strong>Acknowledgement</strong></td>
                                <td>{selectedRow.acknowledgement == "Uploaded" ? "Recieved" : selectedRow.acknowledgement}</td>
                              </tr>
                              <tr>
                                <td><strong>Forward</strong></td>
                                <td>{selectedRow.forwarded}</td>
                              </tr>
                              <tr>
                                <td><strong>ID:</strong></td>
                                <td>{selectedRow._id}</td>
                              </tr>
                              {/* break */}
                              <tr>
                                <td style={{ width: "20%", whiteSpace: "nowrap" }}><strong>Description:</strong></td>
                                <td style={{ width: "20%", whiteSpace: "pre-wrap", wordWrap: "break-word" }}>{selectedRow.description}</td>
                              </tr>
                              {/* <tr>
                                <td style={{ width: "20%", whiteSpace: "nowrap" }}><strong>Correspondence Status:</strong></td>
                                <td style={{ width: "20%", whiteSpace: "pre-wrap", wordWrap: "break-word" }}>{selectedRow.cstatus}</td>
                              </tr> */}
                              <tr>
                                <td><strong>Previous Link:</strong></td>
                                <td>
                                  <ul style={{ listStyleType: 'none' }}>
                                    {selectedRow.files && selectedRow.files.slice(0, -1).map((file, index) => (
                                      <li key={index}>
                                        {file.current ? (
                                          <a
                                            onClick={() => { downloadFile(file.current) }}
                                            style={{ textDecoration: "underline", color: "blue" }}>
                                            {`File ${index + 1}`} - {file.date}
                                          </a>
                                        ) : "No file available"}
                                      </li>
                                    ))}
                                  </ul>
                                </td>
                              </tr>
                              <tr>
                                <td><strong>Previous Acknowledgement Letters:</strong></td>
                                <td>
                                  <ul style={{ listStyleType: 'none' }}>
                                    {selectedRow.files1 && selectedRow.files1.slice(0, -1).map((file, index) => (
                                      <li key={index}>
                                        {file.current ? (
                                          <a
                                            onClick={() => { downloadFile(file.current) }}
                                            style={{ textDecoration: "underline", color: "blue" }}>
                                            {`File ${index + 1}`} - {file.date}
                                          </a>
                                        ) : "No file available"}
                                      </li>
                                    ))}
                                  </ul>
                                </td>
                              </tr>
                              <tr>
                                <td><strong>Link:</strong></td>
                                <td colSpan="1">
                                  {selectedRow.files && selectedRow.files.length > 0 ? (
                                    <pre style={{ whiteSpace: "pre-wrap" }}>
                                      {selectedRow.files.slice(-1).map((file, index) => (
                                        <a
                                          key={index}
                                          onClick={() => { downloadFile(file.current) }}

                                          style={{ textDecoration: "underline", color: "blue" }}
                                        >
                                          Appointment Letter
                                        </a>
                                      ))}
                                    </pre>
                                  ) : (
                                    <span>No appointment letters available</span>
                                  )}
                                </td>
                              </tr>
                              <tr>
                                <td><strong>Acknowledgement Letters:</strong></td>
                                <td colSpan="1">
                                  {selectedRow.files1 && selectedRow.files1.length > 0 ? (
                                    <pre style={{ whiteSpace: "pre-wrap" }}>
                                      {selectedRow.files1.slice(-1).map((file, index) => (
                                        <a
                                          key={index}

                                          style={{ textDecoration: "underline", color: "blue" }}
                                          onClick={() => { downloadFile(file.current) }}
                                        >
                                          Acknowledgement Letter
                                        </a>
                                      ))}
                                    </pre>
                                  ) : (
                                    <span>No acknowledgement letters available</span>
                                  )}
                                </td>
                              </tr>

                              <tr>

                                <td><strong>References:</strong></td>


                                <td>
                                  <ul style={{ listStyleType: 'none' }}>
                                    {selectedRow.refto && selectedRow.refto.map((id, index) => (
                                      <li
                                        key={index}
                                        onClick={() => handleDocumentClick(id)}
                                        style={{ cursor: 'pointer', textDecoration: 'underline' }}
                                      >
                                        <pre style={{ whiteSpace: "pre-wrap" }}>-{getLetterNoById(id)} </pre>{/* Display the letterNo */}
                                      </li>
                                    ))}
                                  </ul>
                                </td>
                              </tr>
                              <tr>
                                <td><strong>Used At :</strong></td>
                                <td>
                                  <ul style={{ listStyleType: 'none' }}>
                                    {selectedRow.reffrom && selectedRow.reffrom.map((id, index) => (
                                      <li
                                        key={index}
                                        onClick={() => handleDocumentClick(id)}
                                        style={{ cursor: 'pointer', textDecoration: 'underline' }}
                                      >
                                        <pre style={{ whiteSpace: "pre-wrap" }}>-{getLetterNoById(id)} </pre> {/* Display the letterNo */}
                                      </li>
                                    ))}
                                  </ul>
                                </td>
                              </tr>
                              {/* Enclosed */}
                              <tr>
                                <td><strong>Enclosed To:</strong></td>
                                <td>
                                  <ul style={{ listStyleType: 'none' }}>
                                    {selectedRow.enclosedto && selectedRow.enclosedto.map((id, index) => (
                                      <li
                                        key={index}
                                        onClick={() => handleDocumentClick(id)}
                                        style={{ cursor: 'pointer', textDecoration: 'underline' }}
                                      >
                                        <pre style={{ whiteSpace: "pre-wrap" }}>-{getLetterNoById(id)} </pre> {/* Display the letterNo */}
                                      </li>
                                    ))}
                                  </ul>
                                </td>
                              </tr>
                              <tr>
                                <td><strong>Enclosed From</strong></td>
                                <td>
                                  <ul style={{ listStyleType: 'none' }}>
                                    {selectedRow.enclosedfrom && selectedRow.enclosedfrom.map((id, index) => (
                                      <li
                                        key={index}
                                        onClick={() => handleDocumentClick(id)}
                                        style={{ cursor: 'pointer', textDecoration: 'underline' }}
                                      >
                                        <pre style={{ whiteSpace: "pre-wrap" }}>-{getLetterNoById(id)} </pre> {/* Display the letterNo */}
                                      </li>
                                    ))}
                                  </ul>
                                </td>
                              </tr>
                              {/* Reply  */}
                              <tr>
                                <td><strong>Reply:</strong></td>
                                <td>
                                  <ul style={{ listStyleType: 'none' }}>
                                    {selectedRow.replyto && selectedRow.replyto.map((id, index) => (
                                      <li
                                        key={index}
                                        onClick={() => handleDocumentClick(id)}
                                        style={{ cursor: 'pointer', textDecoration: 'underline' }}
                                      >
                                        <pre style={{ whiteSpace: "pre-wrap" }}>-{getLetterNoById(id)} </pre> {/* Display the letterNo */}
                                      </li>
                                    ))}
                                  </ul>
                                </td>
                              </tr>
                              <tr>
                                <td><strong>Reply of</strong></td>
                                <td>
                                  <ul style={{ listStyleType: 'none' }}>
                                    {selectedRow.replyfrom && selectedRow.replyfrom.map((id, index) => (
                                      <li
                                        key={index}
                                        onClick={() => handleDocumentClick(id)}
                                        style={{ cursor: 'pointer', textDecoration: 'underline' }}
                                      >
                                        <pre style={{ whiteSpace: "pre-wrap" }}>-{getLetterNoById(id)} </pre> {/* Display the letterNo */}
                                      </li>
                                    ))}
                                  </ul>
                                </td>
                              </tr>
                            </tbody>

                          </table>


                        </>

                      ) : (<div style={{ textAlign: 'center', color: 'gray' }}>
                        <p>No acknowledgement letters available</p>
                      </div>)}
                    </Tab>
                    {/* <Tab eventKey="" title="Trail">
                     <p>In Progress</p>
                    </Tab>
                    <Tab eventKey="trail" title="Trail">
                     <p>hi</p>
                    </Tab> */}

                  </Tabs>
                </div>
                <div
                  style={{
                    // flex: '3', // Increased from '1' to '3' for more space
                    width: "25%",
                    border: '1px solid grey',
                    padding: '0px',
                    textAlign: 'center',
                    // height: '1000px', // Optional: Increase the height as needed
                    // overflowY: 'auto', // Optional: Allows scrolling if content exceeds height
                  }}
                >
                  <h1>References</h1>
                  {selectedRow && (
                    <ul style={{ listStyleType: 'none' }}>
                      {selectedRow.refto && selectedRow.refto.map((id, index) => {
                        let temp = usedcorr?.find((item) => item._id === id);
                        // console.log(temp)
                        renderDocx(temp?.files?.slice(-1)[0]?.current, id)
                        return (
                          <>
                            <div style={{
                              height: "900px",
                              overflowY: 'auto', // Optional: Allows scrolling if content exceeds height
                              border: "1px solid grey",
                              borderRadius: "20px"
                            }}>

                              <pre
                                onClick={() => handleDocumentClick(id)}
                                style={{ cursor: "pointer", padding: "10px", whiteSpace: "pre-wrap", textDecoration: 'underline' }}>-{getLetterNoById(id)} </pre>
                              <p>{temp.description}</p>
                              <li
                                key={index}
                                // onClick={() => {
                                //   handleDocumentClick(id)
                                //   // console.log(id)
                                // }}
                                style={{ cursor: 'pointer', textDecoration: 'underline' }}
                              >
                                {/* Display Letter No */}

                                {temp && temp.files && temp.files.length > 0 ? (

                                  temp.files.slice(-1)[0].current.replace(
                                    /^(https?:\/\/)([^\/]+)/,
                                    (_, protocol, domain) => `${protocol}${bucketName}.${domain.split('.').slice(1).join('.')}`
                                  ).endsWith(".pdf") ? (
                                    <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js`}>
                                      <Viewer fileUrl={temp.files.slice(-1)[0].current.replace(
                                        /^(https?:\/\/)([^\/]+)/,
                                        (_, protocol, domain) => `${protocol}${bucketName}.${domain.split('.').slice(1).join('.')}`
                                      )} />
                                    </Worker>
                                  ) : temp.files.slice(-1)[0].current.replace(
                                    /^(https?:\/\/)([^\/]+)/,
                                    (_, protocol, domain) => `${protocol}${bucketName}.${domain.split('.').slice(1).join('.')}`
                                  ).endsWith(".docx") ? (
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: docx[id]

                                        // "<p>Unable to load the document</p>"
                                      }}
                                      style={{ padding: "15px", border: "1px solid #ddd" }}
                                    />
                                  ) : (
                                    <p>Unsupported file format</p>
                                  )
                                ) : (
                                  <p>No files available</p>
                                )}
                              </li>
                            </div>
                          </>
                        )
                      })}
                    </ul>
                  )}

                </div>
              </div>


            </div>
          </Modal>
        </Container>
      </section>
      {/* edit modal */}
      <Modal show={showModal3} onHide={() => setShowModal3(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Task</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            {/* <Form.Group controlId="formProjectName">
              <Form.Label>Project Name</Form.Label>
              <Form.Control
                type="text"
                value={editprojectname}
                onChange={(e) => setEditprojectname(e.target.value)}
              />
            </Form.Group> */}
            <Form.Group controlId="formTaskSubject">
              <Form.Label>Subject</Form.Label>
              <Form.Control
                type="text"
                value={edittaskSubject}
                onChange={(e) => setEdittaskSubject(e.target.value)}
              />

            </Form.Group>
            <Form.Group controlId="formTaskSubject">
              <Form.Label>Status</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={editstatus}
                onChange={(e) => setEditStatus(e.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="formTaskSubject">
              <Form.Label>Letter No</Form.Label>
              <Form.Control
                type="text"
                value={editletterno}
                onChange={(e) => seteditletterno(e.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="formTaskDescription">
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={edittaskDescription}
                onChange={(e) => setEdittaskDescription(e.target.value)}
              />
            </Form.Group>
            {/* <Form.Group controlId="formTaskDescription">
              <Form.Label>Correspondence Status</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={editcstatus}
                onChange={(e) => setEditcstatus(e.target.value)}
              />
            </Form.Group> */}
            <Form.Group className="mb-3" controlId="editDescription">
              <Form.Label>Type</Form.Label>
              <Form.Select required value={editType} onChange={(e) => setEditType(e.target.value)}>
                <option value="">Select Option</option>
                {Type.map((editType, index) => (
                  <option key={index} value={editType} >
                    {editType}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
            <Form.Group id="pname" className="mb-4">
              <Form.Label>From</Form.Label>
              <InputGroup>
                <InputGroup.Text></InputGroup.Text>
                <Form.Select
                  value={editFrom}
                  onChange={(e) => {
                    setEditFrom(e.target.value);
                  }}
                >
                  <option value="">Select Option</option>
                  {contacts
                    .sort((a, b) => a.name.localeCompare(b.name))
                    // .filter((contact) => contact.type === 'Developer')
                    .map((contact, index) => (
                      <option key={index} value={contact.name}>
                        {contact.name}
                      </option>
                    ))}
                </Form.Select>
              </InputGroup>
            </Form.Group>
            <Form.Group id="pname" className="mb-4">
              <Form.Label>To</Form.Label>
              <InputGroup>
                <InputGroup.Text></InputGroup.Text>
                <Form.Select
                  value={editTo}
                  onChange={(e) => {
                    setEditTo(e.target.value);
                  }}
                >
                  <option value="">Select Option</option>
                  {contacts
                    .sort((a, b) => a.name.localeCompare(b.name))
                    // .filter((contact) => contact.type === 'Agent')
                    .map((contact, index) => (
                      <option key={index} value={contact.name}>
                        {contact.name}
                      </option>
                    ))}
                </Form.Select>
              </InputGroup>
            </Form.Group>
            <Row className="mb-3">
              <Col>
                <Form.Group controlId="editAcknowledgement">
                  <Form.Label>Acknowledgement</Form.Label>
                  {/* <Form.Check
                    type="checkbox"
                    label="Uploaded"
                    checked={editAcknowledgement === "Uploaded"}
                    onChange={(e) => {
                      setEditAcknowledgement(e.target.checked ? "Uploaded" : "");
                      setShowAdditionalFiles(e.target.checked); // Show or hide additional files field
                    }}
                  /> */}
                  <div className="mb-2">
                    <Form.Check
                      type="checkbox"
                      label="Not Required"
                      checked={editAcknowledgement === "Not Required"}
                      onChange={() => {
                        setEditAcknowledgement("Not Required")
                        setShowAdditionalFiles(false)

                      }}
                    />
                  </div>
                  <div>
                    <Form.Check
                      type="checkbox"
                      label="Recieved"
                      checked={editAcknowledgement === "Uploaded"}
                      onChange={() => {
                        setEditAcknowledgement("Uploaded")
                        setShowAdditionalFiles(true)
                      }}
                    />
                  </div>
                  <div>
                    <Form.Check
                      type="checkbox"
                      label="Not Recieved"
                      checked={editAcknowledgement === "Not Recieved"}
                      onChange={() => {
                        setEditAcknowledgement("Not Recieved")
                        setShowAdditionalFiles(false)

                      }}
                    />
                  </div>
                </Form.Group>
              </Col>

              <Col>
                <Form.Group controlId="editForwarded">
                  <Form.Label>Forward</Form.Label>
                  <Form.Check
                    type="checkbox"
                    label="Action Taken"
                    checked={editForwarded === "Action Taken"}
                    onChange={(e) => setEditForwarded("Action Taken")}
                  />
                  <Form.Check
                    type="checkbox"
                    label="Action Pending"
                    checked={editForwarded === "Action Pending"}
                    onChange={(e) => setEditForwarded("Action Pending")}
                  />
                  <Form.Check
                    type="checkbox"
                    label="No Action Required"
                    checked={editForwarded === "No Action Required"}
                    onChange={(e) => setEditForwarded("No Action Required")}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Form.Group controlId="formDate">
              <Form.Label>Date</Form.Label>
              <Form.Control
                type="date"
                value={editdate}
                onChange={(e) => seteditdate(e.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="formFiles">
              <Form.Label>Files</Form.Label>
              <Form.Control
                type="file"
                onChange={handleFileChange}
              />
              {/* <Form.Text className="text-muted">
                Current files: {editFiles.map(file => file.name).join(', ')}
              </Form.Text> */}
            </Form.Group>
            {showAdditionalFiles && (
              <Form.Group controlId="formFiles1">
                <Form.Label>Acknowledgement Files</Form.Label>
                <Form.Control
                  type="file"
                  onChange={handleFileChange1}
                  required
                />
                {/* <Form.Text className="text-muted">
                  Additional files: {editFiles1.map(file => file.name).join(', ')}
                </Form.Text> */}
              </Form.Group>
            )}

          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal3(false)}>
            Close
          </Button>
          {stop ? (<><Col className="d-flex justify-content-end">
            <Button variant="primary" onClick={handleEditSubmit}>Submit</Button>
          </Col></>) : (<></>)}
        </Modal.Footer>
      </Modal>


      {/* <ViewCorrHistory resett={getallcorrespondence} id={id} history={files} setHistory={setfiles} showModal1={showModal1} setShowModal1={setShowModal1} /> */}
      {/* add history */}

      {/* <AddCorrHistory corr={corrdetails} showModal2={showModal2} setShowModal2={setShowModal2} /> */}

      <AddRefEncl settriggerSubmit={settriggerSubmit} corr={corrdetails} used={usedcorr} setused={setusedcorr} showModal2={showModal2} setShowModal2={setShowModal2} fetchCorrespondences={fetchCorrespondences} />


      <div className="mt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          <button
            onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
            disabled={page === 1}
            className="px-4 py-2 bg-gray-100 border rounded disabled:opacity-50"
          >
            Previous
          </button>

          <span className="mx-2">
            Page <strong>{page}</strong> of <strong>{totalPages}</strong>
          </span>

          <button
            onClick={() => setPage((prev) => Math.min(prev + 1, totalPages))}
            disabled={page === totalPages}
            className="px-4 py-2 bg-gray-100 border rounded disabled:opacity-50"
          >
            Next
          </button>
        </div>

        <form
          onSubmit={(e) => {
            e.preventDefault();
            const targetPage = parseInt(e.target.elements.pageInput.value);
            if (targetPage >= 1 && targetPage <= totalPages) {
              setPage(targetPage);
            }
          }}
          className="flex items-center gap-2"
        >
          <label htmlFor="pageInput" className="text-sm">
            Go to page:
          </label>
          <input
            type="number"
            id="pageInput"
            name="pageInput"
            min="1"
            max={totalPages}
            defaultValue={page}
            className="w-20 px-2 py-1 border rounded"
          />
          <button
            type="submit"
            className="px-4 py-1 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Go
          </button>
        </form>
      </div>
    </>
  );
}


